import React from 'react'
import styled from 'styled-components'

const TagLocked = styled.div`
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  background: ${({ theme }) => theme.bg2};
  color: #4afc39;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`
const TagUnlocked = styled.div`
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  background: #4afc39;
  color: #1e1e1e;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`

const TagHypurrFi = styled.div`
  min-width: 120px;
  background: rgb(161, 252, 231);
  height: 22px;
  font-size: 0.75rem;
  font-weight: 400;
  color: rgb(12, 12, 14);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  gap: 2px;

  svg {
    width: 14px;
  }
`

interface TagI {
  variant: 1 | 2 | 3
  children: string | JSX.Element | JSX.Element[] | Element | Element[] | any
  style?: React.CSSProperties
}

const Tag: React.FC<TagI> = ({ variant = 1, style, children }) => {
  return (
    <>
      {variant === 1 && <TagLocked style={{ ...(style ? style : {}) }}>{children}</TagLocked>}

      {variant === 2 && <TagUnlocked style={{ ...(style ? style : {}) }}>{children}</TagUnlocked>}

      {variant === 3 && <TagHypurrFi style={{ ...(style ? style : {}) }}>{children}</TagHypurrFi>}
    </>
  )
}
export default Tag
